import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import id from "./locales/id.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";

export const LANGUAGES = ["en", "id", "zh", "ar"];
export const RTL_LANGUAGES = ["ar"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      id: { translation: id },
      zh: { translation: zh },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "aivos_lang",
      caches: ["localStorage"],
    },
  });

// Keep <html> dir/lang in sync for RTL languages (Arabic).
export function applyDirection(lng) {
  const isRtl = RTL_LANGUAGES.includes(lng);
  document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
}

applyDirection(i18n.resolvedLanguage || "en");
i18n.on("languageChanged", applyDirection);

export default i18n;
